import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  CampaignControllerDtoAppVersionUpdateRequest,
  PerplayCampaignApi,
} from '../../models/src';
import { UPDATE_APP_VERSION_REQUEST } from '../../constants/app/appVersionConstants';
import BaseResponse from '../../models/src/model/BaseResponse';

const api = new PerplayCampaignApi(config.API_CLIENT);

function* updateAppVersionSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoAppVersionUpdateRequest();
    requestData.version = payload.version;
    const res = yield api.apiPerplayCampaignAppVersionUpdatePost(
      { campaignControllerDtoAppVersionUpdateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* rootSaga() {
  yield all([takeEvery(UPDATE_APP_VERSION_REQUEST, updateAppVersionSaga)]);
}

const appVersionSagas = [fork(rootSaga)];
export default appVersionSagas;
